import type { AppGroupSection, Services } from '@wix/app-market-services';

export async function getAppGroupSectionsBySubCategoriesIds({
  subCategoriesIds,
  services,
}: {
  subCategoriesIds: string[];
  services: Services;
}): Promise<AppGroupSection[]> {
  const tagSections = await services.appMarketClientAggregator.getTagSections({
    tagIds: subCategoriesIds,
  });

  return tagSections.getAppGroupSections();
}
